import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiPathEnum } from '../constants/endpoints.enum';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracionCenterAdminService {
  private readonly API_URL = `${environment.API_URL}${ApiPathEnum.ConfigAdmin}`;

  constructor(private http: HttpClient) {}

  getByKey(key: string): Observable<{ data: { clave: string; valor: string; descripcion: string } }> {
    return this.http.get<any>(`${this.API_URL}/${key}`);
  }
}
